import { z } from 'zod';
import LangEnum from '../../../lang/LangEnum';
import { TranslateType } from '../../../modules/translation/translationContext.types';

export const buildPersonSignatureFormSchema = (translate: TranslateType) =>
  z.object({
    role: z.string().trim(),
    email: z
      .string()
      .trim()
      .min(1, translate(LangEnum.GLOBAL_REQUIRED))
      .pipe(z.email(translate(LangEnum.GLOBAL_INVALID_EMAIL))),
    phone: z.string().trim(),
    countryCode: z.string().trim(),
  });

export type PersonSignatureFormValues = z.infer<ReturnType<typeof buildPersonSignatureFormSchema>>;
